import React from 'react';

const Project1 = () => {

    return (
      <div className='mx-10'>
        <div className='text-center mt-16'>
            <h1 className='text-3xl'>Project Details About <span className='text-orange-400 font-semibold'>Phone Resale</span></h1>
        </div>
        <div className="grid gap-6 mt-8 mb-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div className="card card-compact h-full w-full bg-neutral shadow-xl">
            <figure>
              <img
                src="https://i.ibb.co/vJn11Xc/Capture.png"
                className="w-full"
                alt="phone"
              />
            </figure>
            
          </div>
          <div className="card card-compact h-full w-full bg-neutral shadow-xl">
            <figure>
              <img
                src="https://i.ibb.co/55dQkbP/phone1.png"
                className="w-full"
                alt="fitness"
              />
            </figure>
            
          </div>
          <div className="card card-compact h-full w-full bg-neutral shadow-xl">
            <figure>
              <img
                src="https://i.ibb.co/MCXjZhK/phone2.png"
                className="w-full"
                alt="tutor"
              />
            </figure>
            
          </div>
        </div>

        <div>
            <h1 className=' text-center text-3xl text-white font-semibold'>Description about Phone Resale</h1>
            <div>
                <p className='text-xl'>Phone Resale is a buy and sell website. Where you can sell your old phone and buy new one OR you can also exchange your old phone.</p>
            </div>
            <div>
                <h3 className='text-2xl my-1 font-semibold'>Key Features Of Phone Resale website:</h3>
                    <ul>
                        <li className='text-xl'>1. A seller can add their phone to buy and also seller can buy phone if they want.</li>
                        <li className='text-xl'>2. Buyer can buy from the website. and also exchange the old phone</li>
                        <li className='text-xl'>3. When a unknown user visit my website, he/she will see only three route. These are Home, Blog, and login.</li>
                        <li className='text-xl'>4. But an unknown user can see the category.</li>
                        <li className='text-xl'>5. user can log into the website using google, email password.</li>
                        <li className='text-xl'>6. A user must loggined in to buy or add product</li>
                        <li className='text-xl'>7. without login you cannot see any category product.</li>
                    </ul>

                    <h3 className='text-2xl my-1 font-semibold'>Technology Used:</h3>
                    <p className='text-xl'>Tailwind, daisyUI, react hot toast, react, react query, axios, react icons font awesome,react router dom,firebase authentication, mongodb, vercel, vercel cli, nodejs, dotenv, jsonwebtoken, cors, expressjs</p>
            </div>
        </div>
                <div className='flex items-center justify-center mt-8 mb-10'>
                    <a href='https://phone-resale-4aa80.web.app/' className="btn btn-primary mr-3" target='_blank' rel="noreferrer">Live site</a>
                    <a href='https://github.com/Miraz9907/phone-resale-client' className="btn btn-primary mr-3" target='_blank' rel="noreferrer">Github Client</a>
                    <a href='https://github.com/Miraz9907/phone-resale-server' className="btn btn-primary mr-3" target='_blank' rel="noreferrer">Github Server</a>
                </div>
      </div>
    );
};

export default Project1;